export default function LegalPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <h1 className="text-4xl font-bold mb-4">Legal & Policies</h1>
      <p className="text-lg text-gray-700 mb-8">Read our legal information, privacy policy, and terms of service.</p>
    </div>
  )
}
